import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./ButtonGroup.styles";
import { FontAwesomeIcon } from "./FontAwesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import { ButtonGroupNavigation } from "../controls/KeyboardNavigation/ButtonGroupNavigation";
import useQuestion from "../../hooks/useQuestion";
import { useKeyboardNavigationForLookupTable } from "../../hooks/useKeyboardNavigationForLookupTable";

interface GroupButtonInheritedProps {
    size?: "small" | "large";
    isGrid?: boolean;
}

interface GroupButtonProps {
    id?: string;
    text?: React.ReactNode;
    icon?: IconProp;
    inheritedProps?: GroupButtonInheritedProps;
    onClick?(): void;
    active?: boolean;
    disabled?: boolean;
    isPagination?: boolean;
    isEclipse?: boolean;
}

function GroupButton(props: GroupButtonProps) {
    const { id, text, icon, active, disabled, onClick, inheritedProps, isPagination, isEclipse } = props;
    const { size = "large", isGrid } = inheritedProps;
    const question = useQuestion();
    const theme = useTheme();
    const classes = useStyles({ theme, size });
    let content = text;
    if (icon) content = <FontAwesomeIcon icon={icon} />;
    const variableGroupButton = {
        id: id,
    }
    const buttonType = `groupButton${isPagination ? "Pagination" : ""}`;
    const { elementReference, onKeyDown } = !isEclipse && useKeyboardNavigationForLookupTable(
        question.id,
        id,
        variableGroupButton,
        question,
        ButtonGroupNavigation,
        null,
        buttonType,
    );

    return (
        <div
            id={id}
            ref={elementReference}
            onClick={!disabled ? onClick : undefined}
            onKeyDown={onKeyDown}
            className={classNames(
                classes.groupButton,
                isGrid ? classes.groupButtonGrid : classes.groupButtonNoGrid,
                disabled && classes.groupButtonDisabled,
                active && classes.groupButtonActive,
            )}
            tabIndex={isEclipse ? -1 : 0}
            role="button"
        >
            {content}
        </div>
    );
}

interface Props {
    children: any;
}

export default function ButtonGroup(props: Props & GroupButtonInheritedProps) {
    const { children, size } = props;

    const theme = useTheme();
    const classes = useStyles({ theme, size });

    const clonedChildren = React.Children.map(children, (child) => {
        return child && React.cloneElement(child, { inheritedProps: props });
    });

    return <div className={classes.buttonGroup}>{clonedChildren}</div>;
}

ButtonGroup.Button = GroupButton;
